import {QuizQuestion} from 'stores/questions';

class Question extends QuizQuestion {
}

export default Question;
